import { GlobalState } from '../../../types.global';
import { TriviaState } from './types';

export const selectTriviaState = ({ trivia }: GlobalState): TriviaState =>
  trivia;
